// Packages:
import React from 'react'
import {
    OutlinedInput, 
    InputAdornment, 
    FormControl,
    styled
  } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';


// Styles:
const StyledFormControl = styled(FormControl)`
  width: 350px;
  font-size: 14px;
  & .MuiOutlinedInput-root {
    font-size: 14px;
  }
`;


// Functions:
export const GlobalFilter = ({ filter, setFilter }) => {
    // Return:
    return (
            <StyledFormControl variant="outlined">
                <OutlinedInput
                    id="search-account" 
                    type="text"
                    value={filter || ''}
                    onChange={(e) => setFilter(e.target.value)}
                    placeholder="Search"
                    endAdornment={
                        <InputAdornment position="end">
                            <SearchOutlinedIcon />
                        </InputAdornment>
                    }
                    size="small"
                />
            </StyledFormControl>
    )
}